var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.885 7q0-.671.472-1.143a1.56 1.56 0 0 1 1.143-.472q.67 0 1.143.472.472.472.472 1.143t-.472 1.143a1.56 1.56 0 0 1-1.143.472q-.672 0-1.143-.472A1.56 1.56 0 0 1 9.885 7M11.5 23.394l-3.827-3.846 1.394-1.856-1.413-1.903L9 13.836v-1.944a5.57 5.57 0 0 1-2.165-1.984Q6 8.608 6 7q0-2.289 1.606-3.894Q9.21 1.5 11.5 1.5q2.288 0 3.894 1.606Q17 4.71 17 7q0 1.608-.83 2.908A5.5 5.5 0 0 1 14 11.892v9.002zM7.5 7q0 1.439.87 2.491.869 1.053 2.13 1.375v3.442l-.996 1.44 1.429 1.954L9.634 19.4l1.866 1.866 1-1v-9.4q1.26-.322 2.13-1.375T15.5 7q0-1.65-1.175-2.825T11.5 3 8.675 4.175 7.5 7"
  })));
};
export default SvgKey;